import type React from "react";

import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import { Flex } from "@similarweb/ui-components/foundations";

import { AssetsService } from "app/services/AssetsService";

type Props = {
    content: string | React.ReactNode;
};

export const SuccessToast = ({ content }: Props) => {
    return (
        <Flex
            alignItems="center"
            gap="8px"
        >
            <Flex
                width="40px"
                height="40px"
                flexShrink="0"
            >
                <DotLottieReact
                    src={AssetsService.assetUrl("/images/sales-intelligence/checkmark.lottie")}
                    autoplay
                />
            </Flex>
            {typeof content === "string" ? <span>{content}</span> : content}
        </Flex>
    );
};
